export default __webpack_public_path__ + "static/media/output.e40721b5.mp3";